import { render, staticRenderFns } from "./SafetyHealthUpdate.vue?vue&type=template&id=e33452a0"
import script from "./SafetyHealthUpdate.vue?vue&type=script&lang=js"
export * from "./SafetyHealthUpdate.vue?vue&type=script&lang=js"
import style0 from "./SafetyHealthUpdate.vue?vue&type=style&index=0&id=e33452a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports